import type { Referral } from '../../types/membership';
import { readJSON, writeJSON, delay } from './storage';
import { tokenService } from './tokenService';

const KEY = 'teskedo_referral_v1';
const REFERRAL_REWARD = 200; // tokens when a referred user converts

function generateCode(): string {
  return `TES-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
}

export const referralService = {
  getReferral(): Referral {
    let referral = readJSON<Referral | null>(KEY, null);
    if (!referral) {
      referral = { code: generateCode(), clicks: 12, signups: 3, paidConversions: 1, earnings: REFERRAL_REWARD };
      writeJSON(KEY, referral);
    }
    return referral;
  },

  getShareUrl(): string {
    const { code } = this.getReferral();
    const origin = typeof window !== 'undefined' ? window.location.origin : 'https://teskedo.com';
    return `${origin}/signup?ref=${code}`;
  },

  /** Simulates a referred user converting (completing 7 trial days or subscribing). */
  async recordConversion(): Promise<Referral> {
    const referral = this.getReferral();
    const next: Referral = {
      ...referral,
      signups: referral.signups + 1,
      paidConversions: referral.paidConversions + 1,
      earnings: referral.earnings + REFERRAL_REWARD,
    };
    writeJSON(KEY, next);
    await tokenService.earn(REFERRAL_REWARD, 'referral', 'Referral conversion reward', 90);
    return delay(next);
  },

  rewardAmount(): number {
    return REFERRAL_REWARD;
  },
};
